

import templatePostActionMenu from '@/app-template/lib/components/PostActionMenu.vue';

export default {
  components: { templatePostActionMenu },
};
